import { Helmet } from "react-helmet-async";

const SITE = "https://goldenlifesh.com";
const BRAND = "Golden Life Standard Health";

/**
 * Per-page SEO: unique title, meta description, canonical URL, and OG tags.
 * Titles kept under 60 chars, descriptions clipped to ~155 chars to fit SERPs.
 */
export default function SEO({ title, description, path = "/", image = "/home-telehealth.png", noindex = false, noBrand = false }) {
  const fullTitle = noBrand ? title : `${title} | ${BRAND}`;
  const url = SITE + path;
  const ogImage = image.startsWith("http") ? image : SITE + image;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
